import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { FaqDrill, FaqItem } from '@coin/shared/core/util-models';
import { map, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private readonly http = inject(HttpClient);

  public drillDown$ = new Subject<FaqDrill>();
  public changeOfMoreWidth$ = new Subject<boolean>();

  public faqDown(e: FaqDrill): void {
    this.drillDown$.next(e);
  }

  public moreWidthChange(e: boolean): void {
    this.changeOfMoreWidth$.next(e);
  }

  public createInvalidationForHelp(): Observable<unknown> {
    return this.http.post(`${environment.api.cmsService}invalidation`, null);
  }

  public createNewFaq(data: FaqItem[], filename: string): Observable<unknown> {
    return this.http.post(`${environment.api.cmsService}faq/create`, {
      data: JSON.stringify(data),
      filename
    });
  }

  // If filterValue is provided, it filters the FAQ items based on their visibility property
  public getFaq(filename: string, filterValue?: string): Observable<FaqItem[]> {
    return this.http.post<{ item: string }>(`${environment.api.cmsService}faq/get`, { filename }).pipe(
      map(item => JSON.parse(item?.item)),
      map((helpItems: FaqItem[]) =>
        filterValue
          ? helpItems.filter(
              (helpItem: FaqItem) =>
                !helpItem.visibility?.value ||
                helpItem.visibility.value === filterValue ||
                helpItem.visibility.value === 'all'
            )
          : helpItems
      )
    );
  }

  public updateFaq(data: FaqItem[], filename: string): Observable<unknown> {
    return this.http.put(`${environment.api.cmsService}faq/update`, {
      data: JSON.stringify(data),
      filename
    });
  }
}
